import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import {
	BaseInfoType,
	MutHistoryType,
	PageType,
	RevisionType,
} from '@kinderlabs-pos/shared-data-type';

export const getMutInfoHistoryAsync = (rootUrl: string) => async (id: number) =>
	(
		await posAxiosClient.get<PageType<RevisionType<MutHistoryType & BaseInfoType>>>(
			`${rootUrl}/mut/history`,
			{
				params: { id, revisionType: 'ALL' },
			}
		)
	).data;
